import * as PIXI from 'pixi.js';
import Config from './Config';
import { getIsMuted, toggleMute } from './Sounds';

export default class SoundButton extends PIXI.Container {
  constructor() {
    super();

    this.spriteOn = null;
    this.spriteOff = null;

    this.position.set(20, Config.GAME_HEIGHT - 20);
  }

  onResourcesLoaded() {
    this.spriteOn = new PIXI.Sprite(PIXI.Loader.shared.resources['soundOn'].texture);
    this.spriteOn.anchor.set(0, 1);
    this.spriteOn.interactive = true;
    this.spriteOn.buttonMode = true;
    this.spriteOn.visible = !getIsMuted();
    this.spriteOn.on('pointerdown', () => this.toggle());

    this.spriteOff = new PIXI.Sprite(PIXI.Loader.shared.resources['soundOff'].texture);
    this.spriteOff.anchor.set(0, 1);
    this.spriteOff.interactive = true;
    this.spriteOff.buttonMode = true;
    this.spriteOff.visible = getIsMuted();
    this.spriteOff.on('pointerdown', () => this.toggle());

    this.addChild(this.spriteOn, this.spriteOff);
  }

  toggle() {
    toggleMute();

    this.spriteOn.visible = !getIsMuted();
    this.spriteOff.visible = getIsMuted();
  }
}
